import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SUNRISE_FOUNDATIONS_EXPERIENCE = createFcmDetails('sunrise_foundations_experience', {
	owner: 'All',
	context: 'This FCM is used to enable the Sunrise Foundations experience',
	description: `
	This FCM is shared across multiple pages to ensure consistency during the progressive rollout of the Sunrise Foundations experience.
	The goal is to use a single experiment to guide users through the same experience across pages.
	However, it's flexible, you can assign different experiments per page if needed.
	To stop using this FCM, simply disable the experiment using the [enabled: false] flag.

	Groups for the experiment setup:

	C1 (Q2) — Supporter flow:
		- Petition Page (+ PSF)
		- PSF
		- *(TBD scope dependent) Header/Footer
		Experiment Mods to Get By No-Go Performance (~3-4 weeks)

	C2 — Starter flow
		- SAP (incl Login)
		- *(TBD scope dependent) Header/Footer
		Experiment Mods to Get By No-Go Performance (~2-3 weeks)

	Example usage:

	{
		supporterFlow: { enabled: true, experimentName: 'sunrise_full' },
  		starterFlow: { enabled: true, experimentName: 'sunrise_experiment_1' },
	}


	`,
	template: {
		supporterFlow: { enabled: false, experimentName: '' },
		starterFlow: { enabled: false, experimentName: '' },
	},
	import: false,
});
